import { Injectable } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlansStateStructure } from '../../plan-selection/configs/interfaces/plansStateStructure.interface';
import { EnrollManagerService } from './enroll-manager.service';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { PlanUtilityService } from 'src/app/angular-elements/plan-selection/plan-summary-list/plan-utility.service';
import { PlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { PersonPresenterService } from './person-presenter.service';
import { EligibilityProcessorService } from './eligibility-processor.service';

@Injectable({
  providedIn: 'root'
})
export class EnrollPresenterService {

  RelationshipHash = {
    1: 'Self',
    2: 'Spouse',
    3: 'Child',
    4: 'Handicapped Dependent',
    5: 'Domestic Partner/Sponsored'
  };

  PolicyHolderHash = {
    A: 'Currently Employed',
    R: 'Retired',
    N: 'Never/Not Employed'
  };

  constructor(
    private planUtilityService: PlanUtilityService,
    private eligibilityProcessorService: EligibilityProcessorService,
    private enrollManagerService: EnrollManagerService,
    private personPresenterService: PersonPresenterService
  ) { }

  coverageCounty() {
    return this.enrollManagerService.getCoverageCounty();
  }
  productEffectiveDate() {
    const coverage = this.enrollManagerService.getCoverage();
    return coverage.effectiveDateValue;
  }
  productMonthlyPremium() {
    const coverage = this.enrollManagerService.getCoverage();
    return coverage.premiumAmount;
  }
  contractFullName() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.fullName(contract.id);
  }
  onXcontractFullName() {
    const contract = this.enrollManagerService.getOnXContactInformation();
    return this.personPresenterService.fullName(contract.id);
  }
  contractSocialSecurityNumber() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.socialSecurityNumber(contract.id);
  }
  maskedContractSocialSecurityNumber() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.socialSecurityNumber(contract.id).replace(/(\d{5})(\d{4})/, '*****$2');
  }
  contractGender() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.gender(contract.id);
  }
  contractDateOfBirth() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.dateOfBirth(contract.id);
  }
  contractAddress(type) {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.address(contract.id, type);
  }
  contractAddressOnX() {
    const contract = this.enrollManagerService.getOnXContactInformation();
    return this.personPresenterService.addressOnX(contract.id);
  }
  contractEmail() {
    const contract = this.enrollManagerService.getContactInformation() ?
        this.enrollManagerService.getContactInformation() : this.enrollManagerService.getOnXContactInformation();

    return this.personPresenterService.email(contract.id);
  }
  contractPhoneNumber(type) {
    const contract = this.enrollManagerService.getContactInformation() ?
        this.enrollManagerService.getContactInformation() :
            this.enrollManagerService.getOnXContactInformation();

    return this.personPresenterService.phone(contract.id, type);
  }
  contractPCPName(){
    const contract = this.enrollManagerService.getContactInformation() ?
        this.enrollManagerService.getContactInformation() : this.enrollManagerService.getOnXContactInformation();

    return this.personPresenterService.pcpName(contract.id);
  }
  contractPCPNumber(){
    const contract = this.enrollManagerService.getContactInformation() ?
        this.enrollManagerService.getContactInformation() : this.enrollManagerService.getOnXContactInformation();

    return this.personPresenterService.pcpNumber(contract.id);
  }
  contractPCPInd(){
    const contract = this.enrollManagerService.getContactInformation() ?
        this.enrollManagerService.getContactInformation() : this.enrollManagerService.getOnXContactInformation();

    return this.personPresenterService.pcpInd(contract.id);
  }
  contractLanguage(type) {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.language(contract.id, type);
  }
  contractTobaccoUse() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.tobaccoUse(contract.id);
  }
  // contractICHRAorQSEHRA() {
  //   if (window.location.href.indexOf('highmark.com') >= 0) {
  //       return hmStorage.get('enrollData-thirdParty-type') === 'ICHRA' ? 'Yes' : 'No';
  //   } else {
  //       return hmStorage.get('ichra') ? 'Yes' : 'No';
  //   }
  // }
  contractMarketing() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.marketing(contract.id);
  }
  contractSpecialAssistance() {
    const contract = this.enrollManagerService.getContactInformation();
    return this.personPresenterService.specialAssistance(contract.id);
  }
  familyFullName(id: number) {
    return this.personPresenterService.fullName(id);
  }
  familySSN(id: number) {
    return this.personPresenterService.socialSecurityNumber(id);
  }

  maskedFamilySSN(id: number) {
    return this.personPresenterService.socialSecurityNumber(id).replace(/(\d{5})(\d{4})/, '*****$2');
  }
  familyGender(id: number) {
    return this.personPresenterService.gender(id);
  }
  familyDateOfBirth(id: number) {
    return this.personPresenterService.dateOfBirth(id);
  }
  familyAddress(id: number, type) {
    return this.personPresenterService.address(id, type);
  }
  familyAddressOnX(id: number, type?) {
    return this.personPresenterService.addressOnX(id, type);
  }
  familyPCPName(id: number) {
    return this.personPresenterService.pcpName(id);
  }
  familyPCPNumber(id: number) {
    return this.personPresenterService.pcpNumber(id);
  }
  familyPCPInd(id: number) {
    return this.personPresenterService.pcpInd(id);
  }
  familyTobaccoUse(id: number) {
    return this.personPresenterService.tobaccoUse(id);
  }
  familySpecialAssistance(id: number) {
    return this.personPresenterService.specialAssistance(id);
  }
  familyRelationship(id: number) {
    return this.personPresenterService.relationship(id);
  }
  PrimaryApplicantInformation() {
    return this.enrollManagerService.getPrimaryApplicantInformation();
  }
  medicareQuestionInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    return subInformation.medicareQuestionInd ? 'Yes' : 'No';
  }
  privateOrGovernmentInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    return subInformation.privateOrGovernmentInd ? 'Yes' : 'No';
  }
  fullyConsumedBenefitsInd(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        return subInformation[type].fullyConsumedBenefitsInd ? 'Yes' : 'No';
    } else {
        return null;
    }
  }
  replaceAnyOtherCoverageInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    return subInformation.replaceAnyOtherCoverageInd ? 'Yes' : 'No';
  }
  insuranceCarrier(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        return subInformation[type].insuranceCarrier;
    } else {
        return null;
    }
  }
  groupNumber(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if(subInformation[type]) {
        return subInformation[type].groupNumber;
    } else {
        return null;
    }
  }
  policyHolder(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        return subInformation[type].policyHolder;
    } else {
        return null;
    }
  }
  effectiveDate(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        return subInformation[type].effectiveDate;
    } else {
        return null;
    }
  }
  policyNumber(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        return subInformation[type].policyNumber;
    } else {
        return null;
    }
  }
  relationshipToApplicant(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        if (subInformation[type].relationshipToApplicant) {
            return this.RelationshipHash[subInformation[type].relationshipToApplicant];
        } else {
            return null;
        }
    } else {
        return null;
    }
  }
  policyHolderBirthDate(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        return subInformation[type].policyHolderBirthDate;
    } else {
        return null;
    }
  }
  policyHolderEmploymentStatus(type) {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation[type]) {
        if(subInformation[type].policyHolderEmploymentStatus) {
            return this.PolicyHolderHash[subInformation[type].policyHolderEmploymentStatus];
        } else {
            return null;
        }
    } else {
        return null;
    }
  }
  pcpName() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation.pcp) {
        return subInformation.pcp.name !== '' ?
                    subInformation.pcp.name : null;
    } else {
        return 'No PCP Entered';
    }
  }
  pcpNumber() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation.pcp) {
        return subInformation.pcp.number;
    } else {
        return null;
    }
  }
  pcpInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();
    const subInformation = information.otherHealthInsuranceInformation;

    if (subInformation.pcp) {
        return subInformation.pcp.pcpInd === true ? 'Yes' :
                subInformation.pcp.pcpInd === false ? 'No' :
                    null;
    } else {
        return null;
    }
  }
  producerInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    return information.producerInd === true ? 'Yes' :
            information.producerInd === false ? 'No' :
                null;
  }
  producerAgencyNumber() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
       return information.producer.agencyNumber;
    } else {
       return null;
    }
  }
  producerAgencyName() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      return information.producer.agencyName;
    } else {
       return null;
    }
  }
  producerNumber() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
        return information.producer.producerNumber;
    } else {
        return null;
    }
  }
  producerName() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      return information.producer.producerName;
    } else {
      return null;
    }
  }
  businessPhone() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      if ( (information.producer as any).businessPhone) {
        return this.personPresenterService._formatPhoneNumber( (information.producer as any).businessPhone );
      } else if (information.producer.businessPhoneNumber) {
        return this.personPresenterService._formatPhoneNumber(information.producer.businessPhoneNumber);
      }
    } else {
      return null;
    }
  }
  relevantMarketingMaterialsInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      return information.producer.relevantMarketingMaterialsInd === true ? 'Yes' :
              information.producer.relevantMarketingMaterialsInd === false ? 'No' :
                  null;
    } else {
      return null;
    }
  }
  productFeaturesAdviceInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      return information.producer.productFeaturesAdviceInd === true ? 'Yes' :
              information.producer.productFeaturesAdviceInd === false ? 'No' :
                  null;
    } else {
      return null;
    }
  }
  currentCustomerInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      return information.producer.currentCustomerInd === true ? 'Yes' :
              information.producer.currentCustomerInd === false ? 'No' :
                  null;
    } else {
      return null;
    }
  }
  signedCopyInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producer) {
      return information.producer.signedCopyInd === true ? 'Yes' :
              information.producer.signedCopyInd === false ? 'No' :
                  null;
    } else {
      return null;
    }
  }
  producerCollaborationInd() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    return information.producerCollaborationInd === true ? 'Yes' :
                information.producerCollaborationInd === false ? 'No' :
                    null;
  }
  producerCollaborationProducerNumber() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producerCollaboration) {
     return information.producerCollaboration.producerNumber;
    } else {
      return null;
    }
  }
  producerCollaborationAgencyNumber() {
    const information = this.enrollManagerService.getOtherHealthInsuranceInformation();

    if (information.producerCollaboration) {
      return information.producerCollaboration.agencyNumber;
    } else {
      return null;
    }
  }
  relationshipDecoder(primary, person) {
    let relString;

    primary.familyCodes.some(code => {
      if (code.person === person.personID) {
        if(typeof this.eligibilityProcessorService.relationshipCodes.allCodes[code.codeValue] === 'object') {
          relString = this.eligibilityProcessorService.relationshipCodes.allCodes[code.codeValue][person.gender];
        } else {
          relString = this.eligibilityProcessorService.relationshipCodes.allCodes[code.codeValue];
        }
        return true;
      }
    });

    return relString;
  }
  // residencySince(personID: number) {
  //   const contract = this.enrollManagerService.getContactInformation();
  //   const idToUse = personID || contract.id;
  //   return this.personPresenterService.residencySince(idToUse);
  // }

}
